import * as React from "react";
import * as moment from "moment";
import { IContact } from "@nkr/models/index";
import { ITimeSlot, IDay } from "./models";

interface IProps {
    index: number,
    data: ITimeSlot,
    days: IDay[],
    officers: IContact[],
    hours: number[],
    onDayChange: (index: number, day: number) => void,
    onOfficerChange: (index: number, officerId: number) => void,
    onStartTimeChange: (index: number, startTime: string, startTimeRaw: number) => void,
    onEndTimeChange: (index: number, endTime: string, endTimeRaw: number) => void
}

class AddEditTimeSlotRow extends React.Component<IProps, {}> {
    handleDayChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const val = parseInt(e.target.value, 10);
        if (!isNaN(val)) this.props.onDayChange(this.props.index, val);
    }

    handleStartTimeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const rawValue = parseInt(e.target.value.replace(/:/gi, ''), 10);
        if (!isNaN(rawValue)) this.props.onStartTimeChange(this.props.index, e.target.value, rawValue);
    }

    handleEndTimeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const rawValue = parseInt(e.target.value.replace(/:/gi, ''), 10);
        if (!isNaN(rawValue)) this.props.onEndTimeChange(this.props.index, e.target.value, rawValue);
    }

    handleOfficerChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const id = parseInt(e.target.value, 10);
        if (!isNaN(id)) {
            this.props.onOfficerChange(this.props.index, id);
        }
    }

    getOfficerSelectValue = (): string => {
        const { data, officers } = this.props;
        if (!officers.length) return '';
        const matches = officers.some(o => o.id === data.officerId);
        return matches ? String(data.officerId) : String(officers[0].id);
    }

    getDaySelectValue = (): string => {
        const { data, days } = this.props;
        if (!days.length) return '';
        const valid = days.some(d => d.id === data.day);
        return valid ? String(data.day) : String(days[0].id);
    }

    render = () => {
        const endHours = this.props.hours.filter(h => h * 100 >= this.props.data.startTimeRaw);

        // console.log(`startTime: ${this.props.data.startTime} endTime: ${this.props.data.endTime}`)

        return (
            <>
                <tr>
                    <td onClick={(e) => e.stopPropagation()}>
                        <select
                            key={`day-${this.props.index}-${this.props.data.day}`}
                            className="form-control"
                            style={{ marginRight: 10 }}
                            defaultValue={this.getDaySelectValue()}
                            onChange={this.handleDayChange}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {this.props.days.map(day =>
                                <option key={day.id} value={String(day.id)}>{day.name}</option>
                            )}
                        </select>
                    </td>
                    <td onClick={(e) => e.stopPropagation()}>
                        <select
                            key={`start-${this.props.index}-${this.props.data.startTime}`}
                            className="form-control"
                            style={{ marginRight: 10 }}
                            defaultValue={this.props.data.startTime}
                            onChange={this.handleStartTimeChange}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {this.props.hours.map(hour => {
                                let hv = moment().hour(hour).minute(0).format('HH:mm');
                                let ht = moment().hour(hour).minute(0).format('HH:mm');

                                return (
                                    <option key={'start-' + hour} value={hv}>{hour == 0 || hour == 23 ? 'Midnight' : ht}</option>
                                );
                            })}
                        </select>
                    </td>

                    <td onClick={(e) => e.stopPropagation()}>
                        <select
                            key={`end-${this.props.index}-${this.props.data.endTime}`}
                            className="form-control"
                            style={{ marginRight: 10 }}
                            defaultValue={this.props.data.endTime}
                            onChange={this.handleEndTimeChange}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {endHours.map(hour => {
                                let hv = moment().hour(hour).minute(59).format('HH:mm');
                                let ht = moment().hour(hour + 1).minute(0).format('HH:mm');

                                return (
                                    <option key={'end-' + hour} value={hv}>{hour == 23 ? 'Midnight' : ht}</option>
                                );
                            })}
                        </select>
                    </td>

                    <td onClick={(e) => e.stopPropagation()}>
                        <select
                            key={`officer-${this.props.index}-${this.props.data.officerId}`}
                            className="form-control"
                            style={{ marginRight: 0 }}
                            defaultValue={this.getOfficerSelectValue()}
                            onChange={this.handleOfficerChange}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {this.props.officers.map(officer =>
                                <option key={officer.id} value={String(officer.id)}>{officer.firstName}</option>
                            )}
                        </select>
                    </td>
                </tr>
                {this.props.data.overlap && (
                    <tr>
                        <td colSpan={4} className="text-danger">
                            This time slot overlaps another time slot...
                        </td>
                    </tr>
                )}
            </>
        );
    }
}

export default AddEditTimeSlotRow;